import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableRow } from '@mui/material';

export default function ImportedSourceData({ product }) {
  const [open, setOpen] = useState(false);
  const entries = Object.entries(product.import_metadata || {});
  if (!entries.length) return null;
  const label = product.import_metadata?.legacy_ai_contract ? 'Dados anteriores' : 'Dados da planilha';
  return <>
    <Button size="small" onClick={() => setOpen(true)}>{label} ({entries.length})</Button>
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
      <DialogTitle>{label} — {product.name}</DialogTitle>
      <DialogContent><Table size="small"><TableBody>{entries.map(([field, value]) => <TableRow key={field}>
        <TableCell component="th" scope="row">{field}</TableCell>
        <TableCell sx={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>{value && typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value ?? '—')}</TableCell>
      </TableRow>)}</TableBody></Table></DialogContent>
      <DialogActions><Button onClick={() => setOpen(false)}>Fechar</Button></DialogActions>
    </Dialog>
  </>;
}
